import { CodeMirrorInput } from 'browser/components/atomic-elements/atoms/input/code-mirror-input'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const CodeMirrorField = LabelFieldFactory({ InputComponent: CodeMirrorInput })
export { CodeMirrorField }
